import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useApi from '../hooks/useApi';
import { toast } from 'react-toastify';

export default function ReservationPage() {
    const navigate = useNavigate();
    const { id: unitUid } = useParams();
    const { request } = useApi();

    const [guestCount, setGuestCount] = useState(1);
    const [guests, setGuests] = useState([{ name: '', idNumber: '', phone: '' }]);
    const [checkInDate, setCheckInDate] = useState('');
    const [checkOutDate, setCheckOutDate] = useState('');
    const [description, setDescription] = useState('');

    const handleGuestCountChange = (e) => {
        let value = Number(e.target.value);
        if (value > 7) value = 7;
        if (value < 1) value = 1;

        setGuestCount(value);
        setGuests((prev) => {
            const newGuests = [...prev];
            if (value > prev.length) {
                for (let i = prev.length; i < value; i++) {
                    newGuests.push({ name: '', idNumber: '', phone: '' });
                }
            } else {
                newGuests.splice(value);
            }
            return newGuests;
        });
    };

    const handleInputChange = (index, field, value) => {
        setGuests((prev) => {
            const updated = [...prev];
            updated[index][field] = value;
            return updated;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!checkInDate || !checkOutDate) {
            toast.error('Lütfen giriş ve çıkış tarihlerini seçin.');
            return;
        }

        const hasEmpty = guests.some(
            (g) =>
                g.name.trim() === '' ||
                g.idNumber.trim() === '' ||
                g.phone.trim() === ''
        );

        if (hasEmpty) {
            toast.error('Tüm müşteri bilgileri eksiksiz girilmelidir.');
            return;
        }

        const formattedGuests = guests.map((g) => {
            const fullNameParts = g.name.trim().split(' ');
            const name = fullNameParts[0] || '';
            const surname = fullNameParts.slice(1).join(' ') || '';

            return {
                name,
                surname,
                phoneNumber: g.phone.trim(),
                identityNumber: g.idNumber.trim(),
            };
        });

        const payload = {
            status: 1,
            startDate: checkInDate,
            endDate: checkOutDate,
            customerCount: guestCount,
            description,
            unitUid,
            customers: formattedGuests,
        };

        try {
            await request('/bookings', 'POST', payload);
            toast.success('Rezervasyon başarıyla oluşturuldu.');
            navigate('/reservation-success');
        } catch (error) {
            toast.error('Rezervasyon başarısız: ' + (error.message || 'Bilinmeyen hata'));
        }
    };

    return (
        <section className="relative w-full min-h-screen">
            <img
                src="https://cdn.pixabay.com/photo/2020/06/25/10/21/architecture-5339245_1280.jpg"
                alt="background"
                className="absolute inset-0 w-full h-full object-cover brightness-50"
            />
            <div className="relative z-10 flex items-center justify-center min-h-screen px-4 py-10">
                <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl max-w-md w-full p-8">
                    <h2 className="text-white text-3xl font-extrabold text-center mb-6">
                        Rezervasyon Formu
                    </h2>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-white font-medium mb-1">Giriş Tarihi</label>
                            <input
                                type="date"
                                value={checkInDate}
                                onChange={(e) => setCheckInDate(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/20 text-white"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-white font-medium mb-1">Çıkış Tarihi</label>
                            <input
                                type="date"
                                value={checkOutDate}
                                onChange={(e) => setCheckOutDate(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/20 text-white"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-white font-medium mb-1">Kişi Sayısı (max 7)</label>
                            <input
                                type="number"
                                min={1}
                                max={7}
                                value={guestCount}
                                onChange={handleGuestCountChange}
                                className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/20 text-white"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-white font-medium mb-1">Açıklama</label>
                            <textarea
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/20 text-white"
                                placeholder="Aile tatili, iş gezisi, vb."
                            />
                        </div>

                        {guests.map((guest, index) => (
                            <div key={index} className="space-y-3 border border-white/20 p-4 rounded-lg bg-white/10">
                                <p className="text-white font-semibold">{index + 1}. Müşteri</p>
                                <input
                                    type="text"
                                    placeholder="Ad Soyad"
                                    value={guest.name}
                                    onChange={(e) => handleInputChange(index, 'name', e.target.value)}
                                    className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/20 text-white"
                                    required
                                />
                                <input
                                    type="text"
                                    placeholder="TC Kimlik No"
                                    value={guest.idNumber}
                                    onChange={(e) => handleInputChange(index, 'idNumber', e.target.value)}
                                    className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/20 text-white"
                                    required
                                />
                                <input
                                    type="text"
                                    placeholder="Telefon"
                                    value={guest.phone}
                                    onChange={(e) => handleInputChange(index, 'phone', e.target.value)}
                                    className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/20 text-white"
                                    required
                                />
                            </div>
                        ))}

                        <button
                            type="submit"
                            className="w-full py-3 rounded-lg text-white font-semibold bg-gradient-to-r from-[#7F6B52] to-[#989A79] hover:from-[#989A79] hover:to-[#7F6B52] shadow-md hover:shadow-lg transition-all duration-300"
                        >
                            Rezervasyonu Tamamla
                        </button>
                    </form>

                    <button
                        onClick={() => navigate(-1)}
                        className="mt-4 w-full py-2 text-center text-white hover:underline"
                    >
                        Geri Dön
                    </button>
                </div>
            </div>
        </section>
    );
}
